// extracted by mini-css-extract-plugin
module.exports = {"links":"BotHelpfulLinks_links__E8Wl7","adminLinks":"BotHelpfulLinks_adminLinks__XkDjv"};